import React, { useEffect, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AcceptRequest from '../../Models/AcceptRequest.jsx';
import Declineds from './Declineds.jsx';
import Loader from '../../assets/tools/Loder/loader';


const Declined = () => {
  const [showAccept , setShowAccept] = useState(false) ; 
  const {API} = useStateContext();
    const {SetNotification} =useStateContext () ;
  const [user, setUser] = useState(null);
  const [loading, setIsLoading] = useState(true);  
  const [status , setStatus] = useState(null) ; 
  const [code , setCode] =useState (null) ; 

  const { id } = useParams();
  const [l_id , setL_id] = useState(0); 
const navigate = useNavigate() ; 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Registeration/show/${id}`);
        if (response.status === 200) {
          setUser(response.data.user);
          setL_id(response.data.lastAttend.id) ; 
          setCode(response.data.invitation); 
          setIsLoading(false);
          setStatus(response.data.lastAttend.status);
        }
      } catch (error) {
        SetNotification("Error fetching data from Server" , "danger");

      }
    };

    fetchData();

  }, [id , showAccept ]);

 
  const handelDecline = async()=>{
    const confirmed = window.confirm("Are you sure you want to Decline this  Request?");
    if (!confirmed) return ;
    await AxiosClient.post(`/Registeration/Declined/${l_id}`).then((response)=>{
      if (response.status ==200){
        SetNotification("Request has been Declined" , "warning");
        navigate("/Requests"); 
      }
    }); 
   
  }
  const handelDelete  = async()=>{
    const confirmed = window.confirm("Are you sure you want to Delete  this  Request?");
    if (!confirmed) return ;
    await AxiosClient.delete(`/attendances/${l_id}`).then((response)=>{
      if (response.status ==200){
        SetNotification("Request has been Deleted" , "warning");
        navigate("/Requests"); 
      }
    }); 
   
  }

  const handelCancel = async()=>{
   
      navigate("/Requests"); 
    
  }
  return (
    <>
      <div className="card">
        
        {loading ? (
          <Loader label="Loading declined request..." />
        ) : (
          <div className="card-body">
            <div className="card-content text-dark">
              <div className="row">
                <div className="col-6">
                  <p className="card-text">
                    <span className="text-bold"> Name:</span>{' '}
                    {user.first_name }  {user.last_name }
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Email:</span> {user.email}
                </p>
                  <p className="card-text">
                    <span className="text-bold">Position:</span> {user.position}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Gender:</span> {user.gender}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Address:</span> {user.country} {user.city} 
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Organization:</span> {user.organization}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Nationality:</span>{user.nationality}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Phone:</span> {user.phone}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Role:</span> {user.role}
                  </p>
                
                </div>
                <div className="col-6 text-end">
                  <img
                  src={`${API}${user.image}`}
                    className="w-25 border"
                    alt="Profile"
                  />
                </div>
              </div>
              <div class="row">
<div class="col-lg-4 col-md-8 col-12 mx-auto">
  {showAccept && <AcceptRequest user={user} attend={l_id} handelClose={()=>{setShowAccept(false)}}/>}

</div>
</div>
        {
         status !="accepted" ? (<> 
           <button className="btn btn-success m-2" onClick={()=>setShowAccept(true)}>
            Accept
            </button>
            <button className="btn btn-danger m-2 "onClick={()=>handelDelete(user.attendance_id)}>
            Delete 
            </button>
          </>) : <span className='text-success h6'> This request has been accepted </span>
        }
             
              <button className='btn btn-dark m-2' onClick={handelCancel}>
                cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Declined;